import * as React from "react";

interface ILeadWebsiteProps {
    websiteUrl?: string;
}

const LeadWebsite = ({ websiteUrl }: ILeadWebsiteProps) => {
    return (
        <div className="my-3 ms-4 border-start border-2 ps-2">
            <div>Visit their website:</div>
            <div>
                <a href={websiteUrl} rel="nofollow" target="_blank">
                    {websiteUrl}
                </a>
            </div>
        </div>
    );
};

export default LeadWebsite;
